import React from 'react';
import { FormRenderProps } from 'react-final-form';
import { CloseButton } from '../button/CloseButton';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { DialogFooter } from '../dialog/DialogFooter';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { Button } from '../button/Button';
import { makeValidate, modalFormDialog } from '../form/utils';
import { Block, Card, ModalComponentProps, VF } from '..';
import { TableSettingsEnumType } from './types';
import { Yup } from '../validation/yup';

type FormValues = {
  nazev: string;
};
type Props = {
  formRenderProps: FormRenderProps<FormValues>;
  type: TableSettingsEnumType;
} & ModalComponentProps;

const validate = makeValidate(
  Yup.object().shape({
    nazev: Yup.string().required(),
  })
);

const RenameByNameModal = ({
  formRenderProps: { handleSubmit, submitting },
  type,
  onClose,
}: Props) => {
  return (
    <Dialog onClose={onClose} title={`Přejmenovat ${type}`}>
      <DialogBody>
        <Card mode={'edit'}>
          <Block>
            <VF.String
              required
              disabled={submitting}
              label={`Název ${type}u`}
              name="nazev"
            />
          </Block>
        </Card>
      </DialogBody>
      <DialogFooter>
        <ButtonToolbar>
          <CloseButton disabled={submitting} onClick={onClose}>
            Zrušit
          </CloseButton>
          <Button
            style={'primary'}
            disabled={submitting}
            onClick={handleSubmit}
            dataTest={'submit'}
          >
            Uložit
          </Button>
        </ButtonToolbar>
      </DialogFooter>
    </Dialog>
  );
};

export const RenameByNameModalForm =
  // @ts-ignore
  modalFormDialog<FormValues, Props>(RenameByNameModal, {
    validate,
  });
